export function init() {
  storeReviews();

  const notationFilter = document.querySelectorAll('.notation-filter');
  notationFilter.on('click', e => {
    e.preventDefault();

    // Filter by note if filter is not already set
    if (!e.currentTarget.classList.contains('active')) {
      reloadReviewsList(e.currentTarget, reloadReviewsListByNotesSuccess, e.currentTarget.dataset.notes);
      const panelReviewFilter = document.querySelector('div.panel-review-filter');
      if (!checkVisible(panelReviewFilter)) {
        scrollToElement(panelReviewFilter);
      }
    } else {
      // Remove it if already filtered
      reloadReviewsList(e.currentTarget, reInitializeActionsAndEvent);
      window.scrollTo(0, 0);
    }
  });

  const storeReviewsSort = document.querySelectorAll('#sortStoreReviewsBy li');
  storeReviewsSort.on('click', e => {
    e.preventDefault();
    const noteActivated = document.querySelector('.notation-box .active');
    if (noteActivated) {
      reloadReviewsList(e.target, reloadReviewsSortedSuccess, noteActivated.dataset.notes);
    } else {
      reloadReviewsList(e.target, reloadReviewsSortedSuccess);
    }
  });
}

function storeReviews() {
  const page = document.querySelector('html');
  const mobile = page.classList.contains('mobile');
  storeReviewsMoveRatings(mobile);

  $(window).resize(() => {
    const width = $('body').width();
    storeReviewsMoveRatings(width < 769);
  });
}

function loadIframes() {
  const iframes = document.querySelectorAll('#store-reviews-cartridge iframe');
  iframes.forEach(iframe => {
    iframe.setAttribute('src', iframe.dataset.url);
  });
}

function storeReviewsMoveRatings(isMobile) {
  const panelReviewUserSmiley = document.querySelectorAll('.panel-review-user-smiley');

  panelReviewUserSmiley.forEach(element => {
    const fields = element.querySelector('.fields');
    let to = null;

    if (isMobile) {
      to = element.querySelector('.review-info > #criteria-container');
    } else {
      to = element.querySelector('.sidebar');
    }

    fields.parentNode.removeChild(fields);
    to.appendChild(fields);
  });
}

function scrollToElement(element) {
  const header = document.querySelector('#header');
  const headerHeight = header && header.offsetHeight || 0;
  cube.ui.smoothScroll(element, { offset: -headerHeight });
}

function checkVisible(elm) {
  const viewportHeight = $(window).height();
  const scrollTop = 0;
  const y = $(elm).offset().top;
  const elementHeight = $(elm).height();

  return y < viewportHeight + scrollTop && y > scrollTop - elementHeight;
}

function reloadReviewsList(caller, successCallBack, notes) {
  const params = getGenericParameters();
  if (notes) {
    params.notes = notes;
  }
  window.reloadCartridgeContentCollection(
    $(caller),
    'store-reviews-cartridge',
    params,
    successCallBack);
}

function reloadReviewsListByNotesSuccess(caller) {
  reInitializeActionsAndEvent();
  // Hide the filter action link
  const filterActionLink = $('.load-reviews-by-note', caller);
  filterActionLink.hide();
  // Activate the notation-filters that has been clicked on
  const filterActionDiv = filterActionLink.parents('.notation-filter');
  filterActionDiv.addClass('active');
  // Get the cross filter link
  const filterActionSpan = filterActionLink.parent();
  const crossActionSpan = filterActionSpan.prev();
  // Display it
  crossActionSpan.removeClass('hidden');
  crossActionSpan.show();
}

function reloadReviewsSortedSuccess() {
  window.scrollTo(0, 0);
  loadIframes();
}

function reInitializeActionsAndEvent() {
  // Reset notes filters
  $('.notation-filter').removeClass('active');
  const crossActionLinks = $('.action-cross');
  crossActionLinks.hide();
  const filterActionLinks = $('.load-reviews-by-note');
  filterActionLinks.parent().removeClass('hidden');
  filterActionLinks.show();
  // Reset the collapsible texts
  window.UxCollapsibleText.setCollapsedHeight();
  // Move reviews criteria in mobile mode
  storeReviews();
  // Load votes iframes
  loadIframes();
}

function getGenericParameters() {
  const sortActivated = document.querySelector('#sortStoreReviewsBy .active');
  const cartridgeDiv = document.querySelector('#store-reviews-cartridge');

  return {
    direction: sortActivated.dataset.direction,
    sort: sortActivated.dataset.sort,
    store: cartridgeDiv.dataset.storeId
  };
}



// WEBPACK FOOTER //
// ./src/store/store-reviews.js